import React, { Component } from 'react';
import { Label } from '..';
import MenuItem from 'sushiweb/MenuItem';
import { CrossCircleFill } from 'sushiweb/Icons';
import { black, red } from 'sushiweb/tokens/color';
import './searchBox.scss';

export default class SearchBox extends Component {
  static defaultProps = {
    autoFocus: true,
    placeholder: '',
    borderRadius: '2rem',
    menuHeight: '22rem',
    isMultiSelect: false,
    inputStyle: {
      borderRadius: '2rem',
      padding: '0.3rem 1rem',
      fontSize: '1.4rem',
    },
  };

  constructor(props) {
    super(props);
    const { result, value, isMultiSelect } = this.props;
    this.state = {
      data: result,
      showDropdown: false,
      selectedTitle: (!isMultiSelect && value) || '',
      selectedItems: (isMultiSelect && value) || [],
      selectedValues: [],
    };
    this.inputHeight = 'auto';
  }

  componentDidMount = () => {
    this.checkIftagAdded();
    this.calculateInputHeight();
    this.checkPrefilledValues();
  };

  checkPrefilledValues = () => {
    const { value, isMultiSelect } = this.props;
    if (!isMultiSelect) {
      this.setState({
        selectedValues: [],
      });
      return;
    }
    let prefilledValues =
      value &&
      value.map((item) => {
        return item.id;
      });

    this.setState({
      selectedValues: prefilledValues || [],
    });
  };

  calculateInputHeight = () => {
    let input = document.getElementsByClassName('inputWrapper');
    this.inputHeight = input && input[0].clientHeight + 8;
  };

  checkIftagAdded = () => {
    const { addedTags, result } = this.props;
    if (!result) return;
    const tags =
      result &&
      result.map((item) => {
        item['disable'] = item.disable ? true : false;
        addedTags &&
          addedTags.some((ele) => {
            if (ele.title === item.title) {
              item['disable'] = true;
              return true;
            }
            return false;
          });
        return item;
      });
    this.setState({
      data: tags,
    });
  };

  onChange = (event) => {
    const { result } = this.props;
    const inputVal = event.target.value;
    const filterData =
      result &&
      result.filter((item) => {
        return (
          item.title.toLocaleLowerCase().indexOf(inputVal.toLocaleLowerCase()) >
          -1
        );
      });

    this.setState({
      data: filterData,
      selectedTitle: inputVal,
    });
  };

  onFocus = () => {
    this.inputRef && this.inputRef.focus();
    this.setState({
      showDropdown: true,
    });
  };
  onBlur = (event) => {
    if (event.relatedTarget && event.relatedTarget.className === 'menuItem')
      return;
    this.setState({
      showDropdown: false,
    });
  };

  onSelect = (item, selectedVal) => {
    const { onSelect, result, isMultiSelect } = this.props;
    const { selectedItems, selectedValues } = this.state;
    if (isMultiSelect) {
      item['disable'] = true;
    }

    let allItems = isMultiSelect ? [...selectedItems, item] : item;
    let allvalues = isMultiSelect
      ? [...selectedValues, selectedVal]
      : selectedVal;

    this.setState({
      showDropdown: false,
      selectedTitle: isMultiSelect ? '' : item.title,
      data: result,
      selectedValues: allvalues,
      selectedItems: allItems,
    });

    return onSelect(allvalues, allItems);
  };

  removeSelectedTitle = (element) => {
    const { result, onSelect } = this.props;
    const { selectedItems, selectedValues } = this.state;
    let dropdownList = result.map((item) => {
      if (item.title === element.title) {
        item['disable'] = false;
      }
      return item;
    });

    var items = selectedItems.filter((item) => {
      if (item.title !== element.title) {
        return item;
      }
      return null;
    });

    var ids = selectedValues.filter((item) => {
      if (item !== element.id) {
        return item;
      }
      return null;
    });

    this.setState({
      selectedItems: items,
      data: dropdownList,
      selectedValues: ids,
    });
    return onSelect(ids, items);
  };

  getInputValues = () => {
    const { isMultiSelect } = this.props;
    const { selectedItems } = this.state;
    if (isMultiSelect) {
      return (
        selectedItems &&
        selectedItems.map((element, index) => {
          if (!element.name) return null;
          let testing = (
            <div className='editableLabel' key={index}>
              <Label title={element.name} bgColor={red.z500} showIcon={false} />
              <span
                className='cancelCrossImg pointer'
                onClick={this.removeSelectedTitle.bind(this, element)}
              >
                <CrossCircleFill size={15} color={black.z500} />
              </span>
            </div>
          );
          return testing;
        })
      );
    }
    return '';
  };

  render() {
    const {
      autoFocus,
      placeholder,
      menuHeight,
      isMultiSelect,
      error,
      padding = '1rem',
      inputWidth = 'initial',
    } = this.props;
    const { data, showDropdown, selectedTitle, selectedItems } = this.state;
    let selectedLabelBox =
      isMultiSelect && selectedItems && selectedItems.length ? true : false;

    let customStyle = {
      border: '0.5px solid',
      borderColor: error ? '#D02A38' : '#CFCFCF',
    };

    let inputCustomStyle = {
      border: 'none',
      padding: padding,
      width: inputWidth,
    };

    let errorClass = error ? 'error' : '';
    return (
      <div className='col'>
        <div className='searchBoxWithMenus'>
          <div className={`row inputWrapper ${errorClass}`} style={customStyle}>
            {selectedLabelBox && (
              <div className='selectedLabelWrapper'>
                {this.getInputValues()}
              </div>
            )}
            <input
              className={`small input ${errorClass}`}
              ref={(input) => {
                this.inputRef = input;
              }}
              type='text'
              placeholder={placeholder}
              value={selectedTitle}
              onChange={this.onChange}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              autoFocus={autoFocus}
              style={inputCustomStyle}
            />
          </div>
          <div className='triangle-bottom' onClick={this.onFocus}></div>
          {showDropdown && (
            <div
              className='tagsMenu'
              style={{ maxHeight: menuHeight, top: this.inputHeight }}
            >
              {data && data.length ? (
                <React.Fragment>
                  {data.map((item, index) => (
                    <div tabIndex={index} className='menuItem' key={index}>
                      <MenuItem
                        _passClick={this.onSelect.bind(this, item)}
                        key={item.id}
                        label={item.title}
                        desc=''
                        value={item.id}
                        fontSize='14px'
                        disabled={item.disable}
                        isMultiliner={true}
                      />
                    </div>
                  ))}
                </React.Fragment>
              ) : (
                <p className='menuItem noResult'>No result found!</p>
              )}
            </div>
          )}
        </div>
        {error && <p className='red'>{error}</p>}
      </div>
    );
  }
}
